<template>
  <div>
    <mt-header fixed title="业绩" class="title1"></mt-header>
    <div>
      <overview-tips v-if="isShowTips" :flag="0" @clickCell="clickCellHandler"></overview-tips>
      <mt-navbar v-model="active">
        <mt-tab-item v-for="(item, index) in navItems" :key="index" :id="item.id">{{ item.label }}</mt-tab-item>
      </mt-navbar>
      <!-- tab-container -->
      <mt-tab-container v-model="active">
        <mt-tab-container-item v-for="(item, index) in navItems" :key="index" :id="item.id">
          <overview-list-examine v-if="isExamine" :flag="item.id" :actived="active" @clickCell="clickCellHandler"></overview-list-examine>
          <overview-list v-else :flag="item.id" :actived="active" @clickCell="clickCellHandler"></overview-list>
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
  </div>
</template>

<script>
/* global
    PUBLIC_PRODUCT,
    PUBLIC_IS_EXAMINE,
    PUBLIC_OVER_NAVBAR
*/

import OverviewList from '@/components/OverviewList.vue';
import OverviewListExamine from '@/components/OverviewListExamine.vue';
import OverviewTips from '@/components/OverviewTips.vue';
export default {
  name: 'Overview',
  components: {
    OverviewList,
    OverviewListExamine,
    OverviewTips,
  },
  data() {
    return {
      product: PUBLIC_PRODUCT.toLowerCase().trim(),
      isExamine: PUBLIC_IS_EXAMINE,
      isShowTips: false,
      navItems: [],
      active: 0,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'detailed') {
      this.$store.commit('setCache', 'Overview');
    } else {
      this.$store.commit('delCache', 'Overview');
    }
    next();
  },
  mounted() {
    this.$nextTick(() => {
      if (this.product === 'hfpluszs' || this.product === 'xhgj') {
        this.isShowTips = true;
      }
      this.initNavItemsData();
    });
  },
  methods: {
    initNavItemsData() {
      this.navItems = [];
      let navStr = PUBLIC_OVER_NAVBAR;
      // 替换逗号
      navStr = navStr.replace(/，/g, ',');
      // 去掉首逗号
      navStr.indexOf(',') === 0 && (navStr = navStr.substring(1));
      // 去掉尾逗号
      navStr.lastIndexOf(',') === navStr.length - 1 && (navStr = navStr.substring(0, navStr.length - 1));
      // 循环遍历组成新数组
      navStr.split(',').forEach(item =>
        this.navItems.push({
          id: parseInt(item.split('|')[0]),
          label: item.split('|')[1],
        })
      );
    },
    clickCellHandler(showFlag, pageName) {
      if (showFlag === 'show') {
        this.$router.push({ path: '/detailed', query: { active: this.active, pageName: pageName } });
      }
    },
  },
};
</script>
